import { Message } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { getExistingCoveragesSelector } from '../../../recoil/selectors/getExistingCoveragesSelector';
import type { CoverageOpcDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';

const getInterdependentInfoText = (
    termId?: string,
    newTermValue?: number,
    coverages?: CoverageOpcDTO[]
): string | undefined => {
    const coverageIds = coverages?.map((coverage) => coverage.publicID);
    switch (termId) {
        case 'ACCPermanentInjuryToothDamageCovSumInsured': {
            return coverageIds?.includes('ACCHighRiskSportCov')
                ? 'DSS-INTERDEPENDENT-COVERAGE-INFO-ACC-DESCRIPTION'
                : undefined;
        }
        case 'ACCChildPermInjAccCovSumInsured': {
            return coverageIds?.includes('ACCChildPermInjuryCriticalIllnessesCov')
                ? 'DSS-INTERDEPENDENT-COVERAGE-INFO-CHILD-ACC-DESCRIPTION'
                : undefined;
        }
        case 'PRCContentAndBaggageCovDeductible': {
            return coverageIds?.includes('PRCBikeAndPartsCov')
                ? 'DSS-INTERDEPENDENT-COVERAGE-INFO-PRC-DESCRIPTION'
                : undefined;
        }
        case 'MVPLiabilityDeductible_Car20': {
            return newTermValue !== 0 && coverageIds?.includes('MVPComprehensive')
                ? 'DSS-INTERDEPENDENT-COVERAGE-INFO-MVP-DESCRIPTION'
                : undefined;
        }
        case 'MVPComprehensiveDeductible_Car20': {
            return coverageIds?.includes('MVPLiability')
                ? 'DSS-INTERDEPENDENT-COVERAGE-INFO-MVP-DESCRIPTION'
                : undefined;
        }
        default:
            return undefined;
    }
};

const InterdependentChangeInfo = ({
    termId,
    newTermValue
}: {
    termId?: string;
    newTermValue?: number;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const coverages = useRecoilValue(getExistingCoveragesSelector);
    const interdependentInfoText = getInterdependentInfoText(termId, newTermValue, coverages);

    if (!interdependentInfoText) return <></>;

    return (
        <Message className="u-spacing-stack-bottom-3 u-spacing-stack-top-3">
            <h6>{getHippoText('DSS-INTERDEPENDENT-COVERAGE-INFO-HEADER')}</h6>
            {getHippoText(interdependentInfoText)}
        </Message>
    );
};

export default InterdependentChangeInfo;
